(function () {
  var RESIZE_DELAY = 200;

  function getToggle(el) {
    return el.parentNode ? el.parentNode.querySelector('.js-clamp-toggle') : null;
  }

  function needsToggle(el) {
    var wasExpanded = el.classList.contains('is-expanded');

    if (wasExpanded) {
      el.classList.remove('is-expanded');
    }

    var overflows = el.scrollHeight > el.clientHeight + 1;

    if (wasExpanded) {
      el.classList.add('is-expanded');
    }

    return overflows;
  }

  function refresh() {
    var items = document.querySelectorAll('.js-clamp');

    for (var i = 0; i < items.length; i++) {
      var toggle = getToggle(items[i]);

      if (!toggle) {
        continue;
      }

      if (needsToggle(items[i])) {
        toggle.classList.add('is-visible');
      } else {
        toggle.classList.remove('is-visible');
        items[i].classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
      }
    }
  }

  function onClick(e) {
    var toggle = e.target.closest ? e.target.closest('.js-clamp-toggle') : null;

    if (!toggle || !toggle.parentNode) {
      return;
    }

    var el = toggle.parentNode.querySelector('.js-clamp');

    if (!el) {
      return;
    }

    var expanded = el.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refresh, RESIZE_DELAY);
  }

  function init() {
    refresh();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refresh);
    }

    document.addEventListener('click', onClick);
    window.addEventListener('load', refresh);
    window.addEventListener('resize', onResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
